import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Printer, MessageCircle, Pencil, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatRupiah, formatApiError } from "@/lib/format";
import { useSettings } from "@/context/SettingsContext";
import { waLink } from "@/lib/whatsapp";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import DocumentPaper from "@/components/DocumentPaper";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const InvoiceView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { settings } = useSettings();
  const [doc, setDoc] = useState(null);

  const load = () => api.get(`/invoices/${id}`).then((r) => setDoc(r.data)).catch(() => navigate("/invoices"));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

  if (!doc) return <div className="space-y-4"><Skeleton className="h-10 w-40" /><Skeleton className="h-96 w-full max-w-3xl mx-auto" /></div>;

  const changeStatus = async (s) => {
    try {
      await api.patch(`/invoices/${id}/status`, null, { params: { status: s } });
      toast.success("Status diperbarui");
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const sendWA = () => {
    const msg = `Halo ${doc.customer_name},\n\nBerikut invoice *${doc.number}* dari ${settings?.business_name || "kami"}.\nTotal: *${formatRupiah(doc.grand_total)}*\nStatus: ${doc.status}\n\nTerima kasih.`;
    const link = waLink(doc.customer_whatsapp, msg);
    if (!link) { toast.error("Customer tidak memiliki nomor WhatsApp"); return; }
    window.open(link, "_blank");
  };

  return (
    <div className="space-y-6">
      <div className="no-print flex flex-wrap items-center justify-between gap-3">
        <Button variant="ghost" onClick={() => navigate("/invoices")} className="-ml-2"><ArrowLeft className="mr-2 h-4 w-4" />Kembali</Button>
        <div className="flex flex-wrap items-center gap-2">
          <Select value={doc.status} onValueChange={changeStatus}>
            <SelectTrigger className="w-36" data-testid="view-status-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="draft">Draft</SelectItem>
              <SelectItem value="pending">Pending</SelectItem>
              <SelectItem value="paid">Lunas</SelectItem>
              <SelectItem value="unpaid">Belum Bayar</SelectItem>
              <SelectItem value="cancel">Dibatalkan</SelectItem>
            </SelectContent>
          </Select>
          <Button variant="outline" onClick={() => navigate(`/invoices/${id}/edit`)} data-testid="edit-invoice-btn"><Pencil className="mr-2 h-4 w-4" />Edit</Button>
          <Button variant="outline" onClick={() => changeStatus("paid")} className="text-emerald-600"><CheckCircle2 className="mr-2 h-4 w-4" />Lunas</Button>
          <Button variant="outline" className="border-emerald-600 text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-500/10" onClick={sendWA} data-testid="send-wa-btn"><MessageCircle className="mr-2 h-4 w-4" />WhatsApp</Button>
          <Button onClick={() => window.print()} data-testid="print-pdf-btn"><Printer className="mr-2 h-4 w-4" />Cetak / PDF</Button>
        </div>
      </div>
      <DocumentPaper doc={doc} settings={settings} type="invoice" />
    </div>
  );
};

export default InvoiceView;
